import React from 'react';

import { Empty } from 'components';
import * as utils from 'utils';
import { ReactComponent as SearchResultImage } from 'assets/svg/search-result.svg';

export const NoResultsRulesList = () => (
  <Empty width={400} title={utils.string.t('products.filter.noResults')} icon={<SearchResultImage />} padding />
);
